import classNames from 'classnames';
import { ReactNode } from 'react';
import { defineMessage } from 'react-intl';
import styled from 'styled-components';

import { Vertical } from 'atoms/layout/flex';
import { BrandS, BrandXXS } from 'atoms/typography';
import { Ordinal } from 'atoms/typography/Ordinal';
import { Chip } from 'atoms/ui/Chip';

const Root = styled(Vertical)`
  &.fullHeight {
    height: 100%;
  }
`;
const ChipWrapper = styled.div`
  padding: 2px var(--unit);
`;

const LowercaseBrandXXS = styled(BrandXXS).attrs({ as: 'sup' })`
  text-transform: lowercase;
`;

const ChildrenWrapper = styled.div`
  height: 100%;
  & > * {
    height: 100%;
  }
`;

const stepMessage = defineMessage({
  id: 'StepsNumber',
  defaultMessage:
    '{ordinal, selectordinal, one {#<sup>st</sup>} two {#<sup>nd</sup>} few {#<sup>rd</sup>} other {#<sup>th</sup>}} step',
});

type Props = {
  stepNb?: number;
  stepTitle?: ReactNode;
  fullHeight?: boolean;
  children: ReactNode;
};
export const Season26TutorialStep = ({
  stepNb,
  stepTitle,
  fullHeight = true,
  children,
}: Props) => {
  return (
    <Root className={classNames({ fullHeight })}>
      <ChipWrapper>
        <Chip color="transparent">
          <BrandS uppercase>
            {!!stepNb && (
              <Ordinal
                i18n={stepMessage}
                ordinal={stepNb}
                Sup={LowercaseBrandXXS}
              />
            )}
            {stepTitle}
          </BrandS>
        </Chip>
      </ChipWrapper>
      <ChildrenWrapper>{children}</ChildrenWrapper>
    </Root>
  );
};
